import React, { useState, useContext, useEffect } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import ProfileComplete from "./ProfileProgressComplete";
import { Link, useNavigate } from "react-router-dom";
import ProfileTicketEdit from "./ProfileProgressTicketEditProfile";
import ProfileTicketAddress from "./ProfileProgressTicketAddress";
import supabase from "../../Supa";
import { MyContext } from "../../context";

function TicketSteps() {
  const [activeStep, setActiveStep] = useState(0);
  let navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("ProcessUser") && checkUser()) {
      let data = JSON.parse(sessionStorage.getItem("ProcessUser"));
      setName(data.Name);
      setSurname(data.Surname);
      setPhone(data.Phone);
      setCompany(data.Company);
      setIndustry(data.Industry);
      setVat(data.Vat);
    }

    if (sessionStorage.getItem("ProcessAddress") && checkUser()) {
      let data = JSON.parse(sessionStorage.getItem("ProcessAddress"));
      setAddress(data.Address);
      setStreet(data.Street);
      setProvince(data.Province);
      setCity(data.City);
      setCheckboxes(data.Check);
    }
  }, [activeStep]);

  const { userId, updateLogins } = useContext(MyContext);

  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [phone, setPhone] = useState("");
  const [company, setCompany] = useState("");
  const [industry, setIndustry] = useState("");
  const [vat, setVat] = useState("");
  const [process, setProcess] = useState(true);
  const [address, setAddress] = useState("");
  const [street, setStreet] = useState("");
  const [province, setProvince] = useState("");
  const [city, setCity] = useState("");
  const [idcheck, setIdcheck] = useState("");
  const [checkboxes, setCheckboxes] = useState({
    Giga: false,
    ZRange: false,
    XRange: false,
    IStack: false,
  });

  const localSaveUser = {
    Name: name,
    Surname: surname,
    Phone: phone,
    Company: company,
    Industry: industry,
    Vat: vat,
  };

  const localSaveAddress = {
    Address: address,
    Street: street,
    Province: province,
    City: city,
    Check: checkboxes,
  };

  async function submitUser() {
    try {
      const { data, error } = await supabase
        .from("UserTicket")
        .insert({
          User_id: userId,
          Name: name,
          Surname: surname,
          Phone: phone,
          Company_name: company,
          Industry_type: industry,
          Vat_number: vat,
          Process: process,
        });
    } catch (error) {
      console.log(error);
    }
  }

  async function updateAddress() {
    try {
      const { data, error } = await supabase
        .from("UserTicket")
        .update({
          Address: address,
          Street_name: street,
          Province: province,
          City: city,
          Battery_train: checkboxes,
        })
        .eq("User_id", userId);
    } catch (error) {
      console.log(error);
    }
  }

  async function updateUser() {
    try {
      const { data, error } = await supabase
        .from("UserTicket")
        .update({
          Name: name,
          Surname: surname,
          Phone: phone,
          Company_name: company,
          Industry_type: industry,
          Vat_number: vat,
        })
        .eq("User_id", userId);
    } catch (error) {
      console.log(error);
    }
  }

  async function updateProcess() {
    try {
      const { data, error } = await supabase
        .from("UserTicket")
        .update({
          Process: false,
        })
        .eq("User_id", userId);
    } catch (error) {
      console.log(error);
    }
  }

  async function checkUser() {
    try {
      const { data, error } = await supabase
        .from("UserTicket")
        .select("User_id")
        .eq("User_id", userId);

      if (error) throw error;

      if (data.length > 0) {
        setIdcheck(data[0].User_id);
        const userCheckId = data[0].User_id;
        if (userCheckId === userId) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } catch (error) {
      console.log(error);
    }
  }

  checkUser();

  const nextStep = () => {
    if (activeStep < 3) {
      setActiveStep((currentStep) => currentStep + 1);

      if (activeStep === 0) {
        checkUser();
        if (idcheck === userId) {
          console.log("Update Information");
          sessionStorage.setItem("ProcessUser", JSON.stringify(localSaveUser));
          updateUser();

        }
        if (idcheck === "") {
          console.log("Submit Information");
          sessionStorage.setItem("ProcessUser", JSON.stringify(localSaveUser));
          submitUser();
        }
      }
      if (activeStep === 1) {
        console.log("update Address");
        sessionStorage.setItem(
          "ProcessAddress",
          JSON.stringify(localSaveAddress)
        );/**/
        updateAddress();
      }
    } 
  };

  const previousStep = () => {
    if (activeStep !== 0) {
      setActiveStep((currentStep) => currentStep - 1);
    }
  };

  const finishProcess = () => {
    console.log("End")
    updateProcess()
    updateLogins("TicketSystem")
    sessionStorage.setItem('view',"TicketSystem")
    return  navigate("/home")
  };

  const signedIn = (e) => {
    e.preventDefault();
  };

  const isValidName = (word) => {

    return word.length >= 3; 
  };


  const isValidVat = (number) => {

    if(!isNaN(number) && number.length >= 3){
      return true
    }else{
     return false
    }
  };


  let StepInformation = () => {
    switch (activeStep) {
      case 0:
        return (
          <>
            <div style={{ paddingTop: "60px", paddingBottom: "60px" }}>
              <ProfileTicketEdit
                setName={setName}
                setSurname={setSurname}
                setPhone={setPhone}
                setCompany={setCompany}
                setIndustry={setIndustry}
                setVat={setVat}
                industry={industry}
                name={name}
                surname={surname}
                phone={phone}
                vat={vat}
                company={company}
              />
            </div>
          </>
        );
        break;

      case 1:
        return (
          <>
            <div style={{ paddingTop: "60px", paddingBottom: "60px" }}>
              <ProfileTicketAddress
                setAddress={setAddress}
                setStreet={setStreet}
                setProvince={setProvince}
                setCity={setCity}
                setCheckboxes={setCheckboxes}
                checkboxes={checkboxes}
                address={address}
                street={street}
                province={province}
                city={city}
              />
            </div>
          </>
        );
        break;

      case 2:
        return (
          <>
            <ProfileComplete />
          </>
        );
        break;
    }
  };


  return (
    <div>
      <Stepper activeStep={activeStep}>
        <Step>
          <StepLabel>Edit Profile</StepLabel>
        </Step>

        <Step>
          <StepLabel>Edit Address</StepLabel>
        </Step>

        <Step>
          <StepLabel>Complete</StepLabel>
        </Step>
      </Stepper>

      <div>{StepInformation()}</div>
      {activeStep > 0 ? (
        <button
          className="btn2 btn-default"
          onClick={() => previousStep()}
          style={{ marginRight: "20px" }}
        >
          Previous
        </button>
      ) : (
        ""
      )}
      {activeStep === 0 ? (
       

name !== "" && surname !== "" && phone !== "" && company !== "" && industry !== "" && vat !== "" && isValidName(name) && isValidName(surname) && isValidVat(vat) && isValidName(company)?
<button
  className="btn2 btn-default"
  onClick={() => nextStep()}
  style={{ marginRight: "20px" }}
>
  Next
</button>
: <button
className="disabledButton btn-default"
style={{ marginRight: "20px" }}
>
Next
</button>

      ) : (  
        ""
      )}

{activeStep === 1 ? (
       

       address !== "" && street !== "" && province !== "" && city !== "" && isValidName(name) && isValidName(address) && isValidName(street) && isValidName(province)  && isValidName(city)?
       <button
         className="btn2 btn-default"
         onClick={() => nextStep()}
         style={{ marginRight: "20px" }}
       >
         Next
       </button>
       : <button
       className="disabledButton btn-default"
       style={{ marginRight: "20px" }}
       >
       Next
       </button>
       
             ) : ( 
              ""
             )}


{activeStep === 2 ? (
       
       <button
       className="btn2 btn-default"
       onClick={() => finishProcess()}
       style={{ marginRight: "20px" }}
     >
       Finish{" "}
     </button>
       
             ) : (  
              ""
             )}
    </div>
  );
}

export default TicketSteps;
